import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Pushes a `spa_page_view` event to the GTM dataLayer on every route change,
 * exactly once per route (guarded against re-renders / StrictMode), including
 * one fire on initial app load.
 *
 * `page_title` is read after render so the Seo component's title update has
 * already been applied for this route.
 */
export default function useSpaPageTracking() {
  const location = useLocation();
  const lastKey = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastKey.current === path) return;
    lastKey.current = path;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "spa_page_view",
      page_path: path,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}